/**
 * Documentación:
 * 
 * Este archivo contiene el componente TabsMenu, que representa un menú de pestañas
 * para seleccionar diferentes formularios de consulta.
 * 
 * El componente utiliza el estado para mantener la pestaña activa y el formulario seleccionado.
 * Cuando se cambia de pestaña, se actualiza la pestaña activa y se renderiza el formulario correspondiente.
 * 
 * Cada pestaña del menú tiene un botón que, al hacer clic en él, cambia la pestaña activa y renderiza el formulario asociado.
 */

// Importar React y el hook useState desde la biblioteca 'react'
import React, { useState } from 'react';

// Importar los componentes de formularios específicos
import GeneralForm from './GeneralForm';
import ImpuestosForm from './ImpuestosForm';
import LicenciaForm from './LicenciaForm';
import PredialForm from './PredialForm';
import RPPForm from './RPPForm';
import RecursosHumanosForm from './RecursosHumanosForm';
import { UseAuth } from '../hooks/useAuth';
import { getPermisos } from '../utils/utils';
import RegistroCivilForm from './RegistroCivilForm';
import VehicularForm from './VehicularForm';



const tabs = {
  General: "General",
  Impuestos: "Impuestos", 
  Predial: "Predial",
  RPP: "RPP",
  Licencias:'Licencias',
  Registro_Civil: "Registro Civil",
  Vehicular: "Vehicular",

}
 

// Definición del componente funcional TabsMenu
const TabsMenu = () => {
  // Definir estados locales para la pestaña activa y el formulario seleccionado
 
  const [ setSelectedForm] = useState(null);
  const {user} = UseAuth();
  const permisos = getPermisos(user.PERMISOS)

  const [activeTab, setActiveTab] = useState(permisos[0]);


  // Función para manejar el cambio de pestaña
  const handleTabChange = (tab) => {
    setActiveTab(tab); // Actualizar la pestaña activa
    // setSelectedForm(null); // Opcional: restablecer el formulario seleccionado al cambiar de pestaña
  };

  // Función para renderizar el formulario correspondiente a la pestaña activa
  const renderForm = () => {
    switch (activeTab) {
      case 'General':
        return <GeneralForm setForm={setSelectedForm} isActive={activeTab === 'General'} />;
      case 'Impuestos':
        return <ImpuestosForm setForm={setSelectedForm} />;
      case 'Licencias':
        return <LicenciaForm setForm={setSelectedForm} />;
      case 'Predial':
        return <PredialForm setForm={setSelectedForm} />;
      case 'RPP':
        return <RPPForm setForm={setSelectedForm} />;
      case 'Registro_Civil':
        return <RegistroCivilForm setForm={setSelectedForm} />;
      case 'Vehicular':
        return <VehicularForm setForm={setSelectedForm} />;
      default:
        return null;
    }
  };
  

  
  // Map js 
  // renderizado opcional o por estatus en React
  // convertitr un string en un array

  // Renderizar el menú de pestañas y el contenido correspondiente
  return (
    <div className = "menu">
      <div className="tabs">
        {/* Botones para cambiar de pestaña */}
        {permisos.map((x,index) =>{
          if (tabs[x]){
          return(
            <button key={index} onClick={() => handleTabChange(x)}className={activeTab === x ? 'active-tab' : ''}>{tabs[x]}</button>
          
          )
          } 
        })}
        {/* <button onClick={() => handleTabChange('general')}className={activeTab === 'general' ? 'active-tab' : ''}>General</button>
        <button onClick={() => handleTabChange('impuestos')}className={activeTab === 'impuestos' ? 'active-tab' : ''}>Impuestos</button>
        <button onClick={() => handleTabChange('licencia')}className={activeTab === 'licencia' ? 'active-tab' : ''}>Licencias</button>
        <button onClick={() => handleTabChange('predial')}className={activeTab === 'predial' ? 'active-tab' : ''}>Predial</button>
        <button onClick={() => handleTabChange('rpp')}className={activeTab === 'rpp' ? 'active-tab' : ''}>RPP</button>
        <button onClick={() => handleTabChange('registroCivil')}className={activeTab === 'registroCivil' ? 'active-tab' : ''}>Registro Civil</button>
        <button onClick={() => handleTabChange('vehicular')}className={activeTab === 'vehicular' ? 'active-tab' : ''}>Vehicular</button> */}
      </div>

      {/* Contenedor para el contenido de la pestaña seleccionada */}
      <div className="tab-content">
        {renderForm()} {/* Renderizar el formulario correspondiente */}
      </div>
    </div>
  );
};

// Exportar el componente TabsMenu
export default TabsMenu;
